var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.custom? 'image-advertising radius-box-8 pb-3 pr-3 pl-3':'image-advertising radius-box-8 padding-box-16'},[_c('img',{style:(_vm.custom? 'width: 100%;':''),attrs:{"src":_vm.src? _vm.src:'https://i5.walmartimages.com/asr/0c904f0e-73e5-4de0-99ea-f762970e522f_1.b2f398eab6b75e3432bffc486ded7523.jpeg',"alt":"No hay imagen"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }